import { Component, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ContextScreenService } from './context.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';

@Component({
  selector: 'context-screen',
  templateUrl: './context_screen.component.html',
  styleUrls: ['./contextScreen.css']
})
export class ContextScreenComponent {
 public templates;
 public temp;
 public products;
 public subproducts;
 public prodAndSubprod;
 public resultantArray;
 public subproductName;
 public productName;
 public templateId;
 public productId;
 public productId1;
 public subProductID;
  

  constructor(
    private contextService: ContextScreenService,
    private router: Router,
    private fb: FormBuilder,
    public toastr: ToastsManager, vcr: ViewContainerRef
  ) {
    this.toastr.setRootViewContainerRef(vcr);
	this.products = [];
	this.subproducts = [];
	this.prodAndSubprod = [];
	this.resultantArray = [];
	
	//code to fetch the templates
    this.contextService
		.fetchTemplates()
		.subscribe(
				 (templates: any[]) => this.templates = templates,
				 (error) => console.log(error)
	);
	
	// To fetch the products
	/*this.contextService
		.fetchProducts()
		.subscribe(
				 (products: any[]) => this.products = products,
				 (error) => console.log(error)
	);*/
	
	this.contextService
      .fetchProducts()
      .subscribe((products: any[]) => {
        this.products = products;
        if (this.products) {
			/*for(let i=0 ; i<this.products.length; i++){
				let productId = this.products[i]["id"];
				let productName = this.products[i]["name"];
				
				// to fetch the sub products
					this.contextService
					  .fetchSubproducts(productId)
					  .subscribe((subproducts: any[]) => {
						this.subproducts = subproducts;
						console.log(this.subproducts);
						if(this.subproducts.length==0){
							this.prodAndSubprod.push({"productId":productId,"productName":productName,"subproductId":"","subproductName":""});
						}else{
							for(let j=0 ; j<this.subproducts.length; j++){
							let subproductId = this.subproducts[j]["id"];
							let subproductName = this.subproducts[j]["name"];
							this.prodAndSubprod.push({"productId":productId,"productName":productName,"subproductId":subproductId,"subproductName":subproductName});
						} 
						}
					  }, error => {
					   
					  });
				// to fetch the sub products ends 
			
			}*/
        }
      }, error => {
       
      });
   
   
   for (var i =0; i<this.prodAndSubprod; i++){
	this.prodAndSubprod[i].templateId = 0;
   }
  }
  
  getSubProduct(productId){
	console.log(this.productId)	;
  	  var temp = this.search(productId,this.products)
		console.log(temp)
     this.productName = temp.name
      this.productId1 = temp.id
	this.contextService
					  .fetchSubproducts(this.productId1)
					  .subscribe((subproducts: any[]) => {
						this.subproducts = subproducts;
						console.log(this.subproducts);
					  }, error => {
					   
					  });
  }
  
  contextScreenSubmit(subProductID){
  	 // var temp2 = this.search(subProductID,this.subproducts)
    // this.subproductName = temp2.name
     this.subproductName = this.subproducts[0]['name'];	
	let contextName = this.productName+":"+this.subproductName
	console.log(contextName);
	this.resultantArray = 
						{
							"ContextName": contextName,
							"TemplateId": this.templateId,
							"ValidationContextId": null
						};
		this.contextService
				.addTemplateContext(this.resultantArray)
				.subscribe(result => {
					this.toastr.success('Tempate context saved successfully');
		});
	}

	search(nameKey, myArray){
      for (var i=0; i < myArray.length; i++) {
          if (myArray[i].name === nameKey) {
              return myArray[i];
          }
      }
  }
}



// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/context_screen/context_screen.component.ts